export const cesor = (text: string) => {
	return text.slice(0, -5) + "*****";
};
